'use client';

import {
  FeatureSection as KeziosFeatureSection,
  IconMicrophone01,
  IconPhone01,
  IconRefreshCw02,
  IconScissorsCut01,
  IconSearchMd,
  IconTranslate01,
  IconVideoRecorder,
  IconXCircle,
  IconZapFast,
  Spacing,
} from '@kezios/design-system';
import { Button } from '@mantine/core';
import { LinkWithQueryParams } from 'components/website/components/atoms/LinkWithQueryParams/LinkWithQueryParams';
import { useTranslations } from 'next-intl';

export const OtherFeatureSection = ({
  currentLocale,
}: {
  currentLocale: string;
}) => {
  const t = useTranslations('section.otherFeatures');

  return (
    <KeziosFeatureSection
      title={t('title')}
      subtitle={t('subtitle')}
      category={t('category')}
      py={Spacing.s24}
    >
      <KeziosFeatureSection.Item
        key={'caption'}
        title={t('items.caption.title')}
        description={t('items.caption.description')}
        icon={<IconTranslate01 size={24} color="primary" />}
        titleComponent={'h3'}
        cta={
          <Button
            variant="underline"
            component={LinkWithQueryParams}
            href="/autocaptions/"
            locale={currentLocale}
          >
            {t('items.caption.cta')}
          </Button>
        }
      />
      <KeziosFeatureSection.Item
        key={'silence'}
        title={t('items.silence.title')}
        description={t('items.silence.description')}
        icon={<IconScissorsCut01 size={24} color="primary" />}
        titleComponent={'h3'}
        cta={
          <Button
            variant="underline"
            component={LinkWithQueryParams}
            href="/autocutsilences/"
            locale={currentLocale}
          >
            {t('items.silence.cta')}
          </Button>
        }
      />
      <KeziosFeatureSection.Item
        key={'podcast'}
        title={t('items.podcast.title')}
        description={t('items.podcast.description')}
        icon={<IconMicrophone01 size={24} color="primary" />}
        titleComponent={'h3'}
        cta={
          <Button
            variant="underline"
            component={LinkWithQueryParams}
            href="/autocutpodcast/"
            locale={currentLocale}
          >
            {t('items.podcast.cta')}
          </Button>
        }
      />
      <KeziosFeatureSection.Item
        key={'zoom'}
        title={t('items.zoom.title')}
        description={t('items.zoom.description')}
        icon={<IconSearchMd size={24} color="primary" />}
        titleComponent={'h3'}
        cta={
          <Button
            variant="underline"
            component={LinkWithQueryParams}
            href="/autozoom/"
            locale={currentLocale}
          >
            {t('items.zoom.cta')}
          </Button>
        }
      />
      <KeziosFeatureSection.Item
        key={'repeat'}
        title={t('items.repeat.title')}
        description={t('items.repeat.description')}
        icon={<IconRefreshCw02 size={24} color="primary" />}
        titleComponent={'h3'}
        cta={
          <Button
            variant="underline"
            component={LinkWithQueryParams}
            href="/autocutrepeat/"
            locale={currentLocale}
          >
            {t('items.repeat.cta')}
          </Button>
        }
      />
      <KeziosFeatureSection.Item
        key={'resize'}
        title={t('items.resize.title')}
        description={t('items.resize.description')}
        icon={<IconPhone01 size={24} color="primary" />}
        titleComponent={'h3'}
        cta={
          <Button
            variant="underline"
            component={LinkWithQueryParams}
            href="/autoresize/"
            locale={currentLocale}
          >
            {t('items.resize.cta')}
          </Button>
        }
      />
      <KeziosFeatureSection.Item
        key={'broll'}
        title={t('items.autobroll.title')}
        description={t('items.autobroll.description')}
        icon={<IconVideoRecorder size={24} color="primary" />}
        titleComponent={'h3'}
        cta={
          <Button
            variant="underline"
            component={LinkWithQueryParams}
            href="/autobroll/"
            locale={currentLocale}
          >
            {t('items.swearWords.cta')}
          </Button>
        }
      />
      <KeziosFeatureSection.Item
        key={'swearWords'}
        title={t('items.swearWords.title')}
        description={t('items.swearWords.description')}
        icon={<IconXCircle size={24} color="primary" />}
        titleComponent={'h3'}
        cta={
          <Button
            variant="underline"
            component={LinkWithQueryParams}
            href="/autoprofanityfilter/"
            locale={currentLocale}
          >
            {t('items.swearWords.cta')}
          </Button>
        }
      />
      <KeziosFeatureSection.Item
        key={'autoViral'}
        title={t('items.autoViral.title')}
        description={t('items.autoViral.description')}
        icon={<IconZapFast size={24} color="primary" />}
        titleComponent={'h3'}
        cta={
          <Button
            variant="underline"
            component={LinkWithQueryParams}
            href="/autoviral/"
            locale={currentLocale}
          >
            {t('items.autoViral.cta')}
          </Button>
        }
      />
      <KeziosFeatureSection.Item
        key={'autoChapters'}
        title={t('items.autoChapters.title')}
        description={t('items.autoChapters.description')}
        icon={<IconTranslate01 size={24} color="primary" />}
        titleComponent={'h3'}
        cta={
          <Button
            variant="underline"
            component={LinkWithQueryParams}
            href="/autochapters/"
            locale={currentLocale}
          >
            {t('items.autoChapters.cta')}
          </Button>
        }
      />
    </KeziosFeatureSection>
  );
};
